import { Product } from '../../../typings/products';

export const UPDATE_INTERNAL_PRODUCT_DESCRIPTION = 'UPDATE_INTERNAL_PRODUCT_DESCRIPTION';
export type UPDATE_INTERNAL_PRODUCT_DESCRIPTION = typeof UPDATE_INTERNAL_PRODUCT_DESCRIPTION;

export interface UpdateInternalProductDescription {
    type: UPDATE_INTERNAL_PRODUCT_DESCRIPTION;
    product: Product;
}

export function updateInternalProductDescriptionAction(product: Product): UpdateInternalProductDescription {
    return {
        type: UPDATE_INTERNAL_PRODUCT_DESCRIPTION,
        product
    };
}
